import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import Typography from "@material-ui/core/Typography";
import { Grid } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import moment from "moment";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const styles = (theme) => ({
    paper: {
        borderRadius: "10px",
        top: 25,
        maxHeight: "calc(100% - 100px)",
    },
    f: {
        top: "0.5rem",
        right: "0.5rem",
        color: "white",
        position: "absolute",
    },
    tableBody: {
        marginTop: "2rem",
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
}))(MuiDialogActions);

export default function CustomizedDialogs(props) {
    const lang = useSelector((state) => state.domain.locale.lang);
    const { open, followUpsResponse, handleClose, handleCancel, keycloak } = props;
    const isLabourer = keycloak?.hasRealmRole("ContractorLabourerRole");
    const dateFormat = "MMM DD, yyyy";
    const linkWithoutUnderLine = { color: "#00549A", textDecoration: "none", fontWeight: 500 };
    let workorderContractNumber = useSelector((state) => state.contracts[0].vendorNumber);
    const linkWithUnderLine = { color: "#00549A", textDecoration: "none", fontWeight: 500, borderBottom: "1px solid #00549A", cursor: "pointer" };
    const classes = styles();

    const openWODetails = (rowData, workorderContractNumber) => {
        if (
            !isLabourer &&
            rowData.contractorNumber != null &&
            rowData.contractorNumber != undefined &&
            rowData.contractorNumber == workorderContractNumber
        ) {
            window.open("/workorderdetails/" + rowData.duplicateWorkOrderId);
        } else {
            return null;
        }
    };

    return (
        <div>
            <Dialog
                aria-labelledby="customized-dialog-title"
                open={open}
                style={{
                    borderRadius: "10px",
                }}
                PaperProps={{
                    className: classes.paper,
                }}>
                <DialogTitle id="customized-dialog-title" style={{ background: "#E64747", color: "white" }}>
                    <FormattedMessage id="followUp.duplicateWarning" />
                </DialogTitle>
                <DialogContent>
                    <Grid item container xs={12} style={{ fontWeight: 500 }}>
                        <FormattedMessage id="followUp.duplicateTruckRoll.header" />
                    </Grid>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left" style={{ fontWeight: 500 }}>
                                        <FormattedMessage id="followUp.Date" />
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: 500 }}>
                                        <FormattedMessage id="followUp.TN" />
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: 500 }}>
                                        <FormattedMessage id="followUp.WorkActivity" />
                                    </TableCell>
                                    <TableCell align="left" style={{ fontWeight: 500 }}>
                                        <FormattedMessage id="followUp.Status" />
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {followUpsResponse?.body?.createdFollowUpList[0]?.duplicateWorkOrdersDTO?.duplicateWorkOrderDTOList.map((row) => (
                                    <TableRow key={row.name} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                        <TableCell align="left">
                                            <a
                                                style={
                                                    !isLabourer && workorderContractNumber == row.contractorNumber
                                                        ? linkWithUnderLine
                                                        : linkWithoutUnderLine
                                                }
                                                onClick={() => openWODetails(row, workorderContractNumber)}>
                                                {moment(row.createdDate).format(dateFormat)}
                                            </a>
                                        </TableCell>
                                        <TableCell align="left">
                                            <a
                                                style={
                                                    !isLabourer && workorderContractNumber == row.contractorNumber
                                                        ? linkWithUnderLine
                                                        : linkWithoutUnderLine
                                                }
                                                onClick={() => openWODetails(row, workorderContractNumber)}>
                                                {row.customerPhoneNumber}
                                            </a>
                                        </TableCell>
                                        <TableCell align="left">
                                            <a
                                                style={
                                                    !isLabourer && workorderContractNumber == row.contractorNumber
                                                        ? linkWithUnderLine
                                                        : linkWithoutUnderLine
                                                }
                                                onClick={() => openWODetails(row, workorderContractNumber)}>
                                                {lang === "en" ? row.primaryWorkActivityEN : row.primaryWorkActivityFR}
                                            </a>
                                        </TableCell>
                                        <TableCell align="left">
                                            <a
                                                style={
                                                    !isLabourer && workorderContractNumber == row.contractorNumber
                                                        ? linkWithUnderLine
                                                        : linkWithoutUnderLine
                                                }
                                                onClick={() => openWODetails(row, workorderContractNumber)}>
                                                {lang === "en" ? row.statusEnglish : row.statusFrench}
                                            </a>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={handleCancel}
                        style={{
                            position: "absolute",
                            left: "0.5rem",
                            fontWeight: "bold",
                            textTransform: "none",
                            background: "var(--white-background)",
                            boxShadow: "0px 2px 4px rgb(0 0 0 / 14%), 0px 3px 4px rgb(0 0 0 / 12%), 0px 1px 5px rgb(0 0 0 / 20%)",
                            color: "var(--blue-bell)",
                        }}
                        align="left">
                        <FormattedMessage id="followUp.cancelWO" />
                    </Button>
                    <Button
                        style={{
                            fontWeight: "bold",
                            background: "#e5f2fe",
                            border: "1px solid #e5f2fe",
                            textTransform: "none",
                            background: "#00549A",
                            color: "#FFFFFF",
                        }}
                        align="right"
                        onClick={handleClose}>
                        <FormattedMessage id="followUp.Createnewfollowup" />
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
